/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react"
import types from "prop-types"
import clsx from "clsx"

const IconTapTarget = ({
  children, className = "", label = "", onClick = undefined, ...rest
}) => (
  <button
    className={clsx(className, "p-4 h-full cursor-pointer")}
    aria-label={label}
    {...(onClick ? { onClick } : {})}
    {...rest}
  >
    {children}
  </button>
)

IconTapTarget.propTypes = {
  children: types.node.isRequired,
  className: types.string,
  label: types.string,
  onClick: types.func,
}

export default IconTapTarget
